import React from 'react';
import {AbstractStand} from "./AbstractStand";

export const Stand8 = (props) => <AbstractStand height="20" width="40" type={"8"} {...props}/>;

